import { render, staticRenderFns } from "./Models-Single.vue?vue&type=template&id=7e169fda&scoped=true"
import script from "./Models-Single.js?vue&type=script&lang=js&external"
export * from "./Models-Single.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e169fda",
  null
  
)

export default component.exports